import 'css-chunksrc/client/pages/capacityPage/styles.scss';export default {
  "capacityPage": "_capacityPage_ch9bq_1",
  "header": "_header_ch9bq_9",
  "profileNavigation": "_profileNavigation_ch9bq_19",
  "title": "_title_ch9bq_27",
  "menu": "_menu_ch9bq_33",
  "unit": "_unit_ch9bq_42",
  "content": "_content_ch9bq_48",
  "tableContainer": "_tableContainer_ch9bq_59",
  "error": "_error_ch9bq_65",
  "empty": "_empty_ch9bq_66",
  "retry": "_retry_ch9bq_77"
};